import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {currentResource} from '../../../util/utils';
import ErrorSummary from '../ErrorSummary/ErrorSummary';
import {setIsModalOpen} from '../../../actions/setismodalopen';
import CreateEditTagGroupModal from '../CanvasForm/Bodies/BodyTypes/SampleList/CreateEditTagGroupModal/src';
import {entities} from '../../../util/uiconstants';
import Utility from '../../../util/utilityfunctions';
import {createTagGroup, updateTagGroup, getTagGroupById} from '../../../actions/TagGroup/tagGroupActions';
import {clearErrors} from '../../../actions/erroractions';

export default function CreateEditTagGroupModalWrapper(props) {
	const {isCreate, showModal, setShowModal, onClose, entityId} = props;
	const [engagementId] = useSelector((state) => [state.engagementId]);
	const dispatch = useDispatch();
	const tagGroupItem = useSelector((state) => state.tagItems.tagGroups.byId[entityId]);

	useEffect(() => {
		if (showModal) {
			dispatch(setIsModalOpen(true));
		} else {
			dispatch(setIsModalOpen(false));
		}
		dispatch(clearErrors());
		return () => {
			dispatch(clearErrors());
		};
	}, [showModal]);

	const getTagGroupDataById = () => {
		return dispatch(getTagGroupById(engagementId, tagGroupItem?.tagGroupId));
	};

	return (
		<>
			{isCreate && (
				<CreateEditTagGroupModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					createTagGroupAction={(data) => dispatch(createTagGroup(engagementId, data))}
					labels={currentResource.CreateEditTagGroupLabels}
					onClose={onClose}
					theme={Utility.getTheme()}
					errorComponent={<ErrorSummary />}
					entityId={entities.SampleItem}
				/>
			)}
			{!isCreate && (
				<CreateEditTagGroupModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					tagGroupItem={tagGroupItem}
					updateTagGroupAction={(data) => dispatch(updateTagGroup(engagementId, tagGroupItem?.tagGroupId, data))}
					getById={() => getTagGroupDataById()}
					labels={currentResource.CreateEditTagGroupLabels}
					onClose={onClose}
					theme={Utility.getTheme()}
					errorComponent={<ErrorSummary />}
					entityId={entities.SampleItem}
					isEditModal={true}
				/>
			)}
		</>
	);
}
